<template>
    <v-sheet class="desc-list">
        <v-card-title class="desc-list__title">
            <span>필드 목록</span>
            <template v-if="mobile">
                <v-spacer />
                <v-btn text icon tile class="my-n1 mr-n1" @click="$emit('exit')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-card-title>
        <v-divider />
        <v-card-text class="d-flex flex-column" style="gap: 8px; overflow-y: auto">
            <template v-for="side in sides">
                <list-side v-model="form" v-bind="{ side, mobile }" @input="emit" :key="side" />
            </template>
        </v-card-text>
    </v-sheet>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, initEmploymentForm } from "@/assets/variables";

import ListSide from "./list/list-side.vue";

const sides = Object.keys(EMPLOYMENT_FIELD_SIDES);

export default {
    components: {
        ListSide,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentForm },
        mobile: { type: Boolean, default: false },
    },
    data: () => ({
        form: initEmploymentForm(),
        sides,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
.desc-list {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__title {
        font-size: 16px !important;
        height: 60px;
    }
}
</style>
